"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Escrow = void 0;
var React = _interopRequireWildcard(require("react"));
var styles = _interopRequireWildcard(require("./Escrow.css"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const Escrow = props => {
  return /*#__PURE__*/React.createElement("div", {
    className: styles['row']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['key']
  }, "\u0421\u0447\u0435\u0442\u0430 \u044D\u0441\u043A\u0440\u043E\u0443"), /*#__PURE__*/React.createElement("div", {
    className: styles['value']
  }, props.escrow));
};
exports.Escrow = Escrow;